/**
 * Utility functions for video-related operations
 */

/**
 * Checks if a video URL is available by making a HEAD request
 * @param url - The video URL to check
 * @returns Promise that resolves to true if the URL is available, false otherwise
 */
export const checkVideoUrlAvailability = async (
  url: string
): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: 'HEAD' })
    return response.ok
  } catch (error) {
    return false
  }
}
